// import createPersistedState from 'vuex-persistedstate'
import * as apiSearchConditions from '@/api/search-condition'
import * as apiTags from '@/api/tag'
import * as _ from 'lodash'

const getDefaultState = () => {
  const defaults = {
    lists: [],
    tags: [],
    complete: false,
    canload: true,
    start: 0,
    per_page: 30,
    count: null,
    qa: null,
    knowledge: null,
    currentId: null,
    filterTags: [],
    filterTypes: []
  }

  return defaults
}

const searchCondition = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getCurrentList: (state) => _.find(state.lists, list => list.id === state.currentId)
  },
  mutations: {
    setLists: (state, lists) => {
      state.lists.push(...lists)
    },
    setStart: (state, num) => {
      state.start = num
    },
    subtractionStart: (state) => {
      state.start--
    },
    setCount: (state, num) => {
      state.count = num
    },
    subtractionCount: (state) => {
      state.count--
    },
    setComplete: (state) => {
      state.complete = true
    },
    setCanload: (state, boolean) => {
      state.canload = boolean
    },
    setTagLists: (state, lists) => {
      state.tags.splice(0, state.tags.length)
      state.tags.push(...lists)
    },
    resetLists: (state) => {
      state.lists.splice(0, state.lists.length)
    },
    resetComplete: (state) => {
      state.complete = false
    },
    resetAll: (state) => {
      Object.assign(state, getDefaultState())
    },
    setId: (state, id) => {
      state.currentId = id
    },
    updateList: (state, { index, id, title, tags }) => {
      const prev = state.lists[index]
      prev.title = title
      prev.tags = tags
      state.lists.splice(index, 1, prev)
    },
    deleteList: (state, index) => {
      // const prev = state.lists[index]
      state.lists.splice(index, 1)
    },
    setFilterTags: (state, tags) => {
      // state.search.filterTags.splice(0, state.search.filterTags.length)
      state.filterTags = tags
    },
    setFilterTypes: (state, types) => {
      // state.search.filterTags.splice(0, state.search.filterTags.length)
      state.filterTypes = types
    }
  },
  actions: {
    getCount: ({ commit, state }) => {
      const params = {
        tags: state.filterTags,
        types: state.filterTypes
      }
      apiSearchConditions
        .count(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('setCount', data.count)
          }
        })
    },
    setFilterTags: async ({ commit }, tags) => {
      await commit('setFilterTags', tags)
    },
    setFilterTypes: async ({ commit }, types) => {
      await commit('setFilterTypes', types)
    },
    getLists: async ({ commit, state, dispatch }) => {
      const params = {
        start: state.start,
        per_page: state.per_page,
        tags: state.filterTags,
        types: state.filterTypes
      }
      if (state.canload) {
        commit('setCanload', false)
        const res = await apiSearchConditions
          .list(params)
          .then(async(response) => {
            const { data } = response
            if (data.status === 0) {
              const { lists } = data
              if (lists && lists.length > 0) {
                const start = state.start + lists.length
                await commit('setStart', start)
                await commit('setLists', lists)
                commit('setCanload', true)
                if (lists.length < state.per_page) {
                  commit('setComplete')
                }
              } else {
                commit('setCanload', true)
                commit('setComplete')
              }
              dispatch('getCount')
            }
            return data
          })
        return res
      }
    },
    // 一覧を即座にリセットする
    resetListsImmediately: ({commit}) => {
      commit('resetLists')
      commit('resetComplete')
      commit('setStart', 0)
      commit('setCount', null)
    },
    resetLists: ({ commit, state }) => {
      // 前回から絞り込みの条件が変わっていた場合は一覧をリセットする
      const interval = setInterval(() => {
        if (state.canload) {
          commit('resetLists')
          commit('resetComplete')
          commit('setStart', 0)
          commit('setCount', null)
          clearInterval(interval)
        }
      }, 100)
    },
    getTags: async ({commit}) => {
      const params = {
        type: 'search'
      }
      await apiTags
        .list(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const { lists } = data
            commit('setTagLists', lists)
          }
        })
    },
    setEditId: async ({ commit }, id) => {
      await commit('setId', id) 
    },
    update: async ({ commit, state }, params) => {
      const res = await apiSearchConditions
        .update(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const save = _.clone(params)
            const index = _.findIndex(state.lists, list => list.id === params.id)
            save.index = index
            save.tags = _.map(params.tags, tag => {
              return { id: null, name: tag, num: null }
            })
            commit('updateList', save)
          }

          return response
        })

      return res
    },
    delete: async ({ commit, state }, params) => {
      const res = await apiSearchConditions
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const index = _.findIndex(state.lists, list => list.id === params.id)
            commit('deleteList', index)
            commit('subtractionCount')
            commit('subtractionStart')
          }
          return response
        })
      
      return res
    },
    resetAllState({ commit }) {
      commit('resetAll')
    }
  }
}

export default searchCondition
